import React, { Component, useEffect, useRef, useState } from 'react'

import Icon from '../Icon2/Icon'
import Tooltip from '../Tooltip/Tooltip'
import Button from '../Button/Button'
import { modulesById } from './util/constant'

const AdvanceSearchHeader = (props) => {
  const { t = (key: string) => '' } = props

  useEffect(() => {
    if (props.headerSearchRef.current && props.isVisible) {
      props.headerSearchRef.current.focus()
    }
  }, [props.isVisible])


  return (
    <div className="AdvancedQueryView__header" tabIndex={0} ref={props.headerSearchRef}>
      <div className="flex-v-center">
        <div className="advanceSearchCloseIcon flex-v-center">
          <Tooltip content={t('AdvanceSearchV2.AdvanceSearchHeader.close') || 'Close'} position={'top'} showArrow={false} interactive={false}>
            <Button
              id="advancesearchiconclose"
              testId="cs-advance-search-clear"
              buttonType="light"
              size="regular"
              version="v2"
              onClick={() => props.setAdvSearchVisibility(false)}
              onlyIcon={true}>
              <Icon version="v2" icon="CloseNoborder" size="medium" />
            </Button>
          </Tooltip>
        </div>
        <div className="moduleInfo">
          <div className="advSearchText">{t('AdvanceSearchV2.AdvanceSearchHeader.advanced_search') || 'Advanced Search'}</div>
          <div className="moduleText">{modulesById[props.selectedModule]}</div>
        </div>
      </div>
      <div className="flex-v-center">
        <Button size="large" buttonType="secondary" className="mr-15" onClick={props.handleClearInput} testId="cs-advance-search-reset">
          {t('AdvanceSearchV2.AdvanceSearchHeader.reset') || 'Reset'}
        </Button>
        <Button size="large" onClick={props.handleSearchSubmit} testId="cs-advance-search-results">
          {t('AdvanceSearchV2.AdvanceSearchHeader.search') || 'Search'}
        </Button>
      </div>
    </div>
  )
}

export default AdvanceSearchHeader
